import { Tooltip as ChakraTooltip } from "@chakra-ui/react";
import { ReactNode, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";

type TooltipProps = {
  label: ReactNode;
};
export const Tooltip = ({ label }: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <ChakraTooltip
      label={label}
      isOpen={isVisible}
      closeDelay={2000}
      onClose={() => setIsVisible(false)}
      pointerEvents="all"
      color="textSecondary"
      fontSize="12px"
      bg="backgroundCard"
      p="8px"
      borderRadius="8px"
    >
      <span>
        <AiOutlineInfoCircle
          onMouseEnter={() => setIsVisible(true)}
          onClick={() => setIsVisible(true)}
        />
      </span>
    </ChakraTooltip>
  );
};

export default Tooltip;
